// extracted by mini-css-extract-plugin
module.exports =  {"contact-seller-button":"E2EYhou","contactSellerButton":"E2EYhou","avatar":"rmSuq9X"};